import { render, staticRenderFns } from "./add-organize.vue?vue&type=template&id=6b0a5e21&scoped=true"
import script from "./add-organize.vue?vue&type=script&lang=ts"
export * from "./add-organize.vue?vue&type=script&lang=ts"
import style0 from "./add-organize.vue?vue&type=style&index=0&id=6b0a5e21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a5e21",
  null
  
)

export default component.exports